import * as types from "../constants/ActionTypes";

const selectedChatMonitoring = (state = null, action) => {
  switch (action.type) {
    case types.CHANGE_SELECTED_CHAT_MONITORING:
      return action.chatInfos;
    case types.ADD_ENTERPRISE_ADDITIONAL_INFOS:
      if (!Boolean(state)) return state;
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          enterpriseAdditionalInfos: action.enterpriseAdditionalInfos,
        };
      }
      return state;
    case types.ADD_CONTACT_ADDITIONAL_INFOS:
      if (!Boolean(state)) return state;
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          contactAdditionalInfos: action.contactAdditionalInfos,
        };
      }
      return state;
    default:
      return state;
  }
};

export default selectedChatMonitoring;
